export default __webpack_public_path__ + "static/media/think-before-i-talk.75b9492a.mp3";